/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, FormControlLabel, Grid, Radio, Typography } from '@mui/material';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import React, { useEffect, useState } from 'react';
import { DataTable } from '../DataTable';
import { ProceedSaveLater, SubHeading } from './components';
import { MFTextField } from '../../lib/formik';
import UseRadioGroup from '../../lib/formik/Radio';
import MFSelectField from '../../lib/formik/SelectField';
import AddIcon from '@mui/icons-material/Add';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  APMIFlow,
  CompanyMasters,
  SHOW_SECTION_FILLED_BY_INVESTOR_CHECKBOX,
  StockExchangeMasters,
  USER_ROLES,
  YesNoMaster,
} from '../../utils/constant';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ConfirmationDialog } from '../commonComponents';
import { disclosureOfExcludedSchema } from '../../utils/schema';
import { useDispatch, useSelector } from 'react-redux';
import { showError } from '../../redux-store/actions/auth';
import { useHistory, useParams } from 'react-router';
import {
  ApplicationProps,
  ExcludedCompanyType,
  InvestorEditRouteLinkObj,
} from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import { useSnackbar } from 'notistack';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkIfApplicationIsNonIndividual,
  fieldValidateForInvestor,
  getDisableStatusForjointHolder,
  getInvestorRouteLinks,
  isPhygital,
  saveForLater,
  saveForLaterInvestorPhotoCapture,
} from '../../utils/utilityFunctions';
import { updateApplication } from '../../redux-store/actions/application';
import MFCheckbox from '../../lib/formik/Checkbox';
import { sectionFilledByInvestor } from '../../utils/declaration';
import { refLoginCheck } from '../Investments/investor-application';
import { InvestorEditErrorObj } from '../../redux-store/reducers/investorEditSections';

type updatedCompanyType = ExcludedCompanyType & {
  sno?: number;
};

type Values = {
  isDisclosureOfExclusionsToBeFilledByInvestor: boolean;
  excludedCompaniesCheck: string;
  excludedcompanies: updatedCompanyType[];
  saveType: string;
};

const initialValues: Values = {
  isDisclosureOfExclusionsToBeFilledByInvestor: APMIFlow ? true : false,
  excludedCompaniesCheck: '',
  excludedcompanies: [],
  saveType: 'save and proceed',
};

const newExcludedCompany: updatedCompanyType = {
  isActive: true,
  companySectorType: 'Company',
  stockExchangeName: '',
  companySectorName: '',
  sno: 0,
};

function DisclosureOfExcludedTable({
  values,
  setDialogBox,
  amcuserAsInvestor,
}: // setValues,
{
  values: Values;
  setDialogBox: any;
  amcuserAsInvestor: boolean;
  // setValues: FormikHelpers<Values>['setValues'];
}): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);

  const headers = [
    {
      header: 'No.',
      label: 'no',
      renderEditDeleteCell: (row: updatedCompanyType, index: number): JSX.Element => {
        return (
          <>
            <Typography sx={{ fontSize: 14, fontWeight: 500 }}>{`${index + 1}`}</Typography>
          </>
        );
      },
    },
    {
      header: 'Type',
      renderEditDeleteCell: (row: updatedCompanyType, index: number): JSX.Element => {
        return (
          <MFSelectField
            name={`excludedcompanies.${row.sno}.companySectorType`}
            items={CompanyMasters.map((type) => ({ key: type, value: type }))}
            applyLabelStyles={true}
            disabled={true}
          />
        );
      },
    },
    {
      header: 'Name of Company',
      renderEditDeleteCell: (row: updatedCompanyType, index: number): JSX.Element => {
        return (
          <MFTextField
            name={`excludedcompanies.${row.sno}.companySectorName`}
            placeholder=""
            disabled={getDisableStatusForjointHolder(
              role,
              referenceDetail.applicant_type,
              amcuserAsInvestor
            )}
          />
        );
      },
    },
    {
      header: 'Exchange',
      renderEditDeleteCell: (row: updatedCompanyType, index: number): JSX.Element => {
        return (
          <MFSelectField
            name={`excludedcompanies.${row.sno}.stockExchangeName`}
            items={Object.keys(StockExchangeMasters).map((item) => ({
              key: StockExchangeMasters[item],
              value: item,
            }))}
            applyLabelStyles={true}
            disabled={getDisableStatusForjointHolder(
              role,
              referenceDetail.applicant_type,
              amcuserAsInvestor
            )}
          />
        );
      },
    },
    {
      header: '',
      renderEditDeleteCell: (row: updatedCompanyType, index: number): JSX.Element => {
        return (
          <>
            {(values.excludedcompanies?.filter((company) => company.isActive).length > 1 ||
              getDisableStatusForjointHolder(
                role,
                referenceDetail.applicant_type,
                amcuserAsInvestor
              )) && (
              <DeleteOutlineIcon
                sx={{ cursor: 'pointer', mt: { xs: 4, sm: 1, md: 1, lg: 2, xl: 1 } }}
                color={'primary'}
                onClick={() => {
                  setDialogBox({ Index: row.sno });
                }}
              />
            )}
          </>
        );
      },
    },
  ];
  return (
    <DataTable
      tableData={values.excludedcompanies?.filter((data) => data.isActive)}
      tableHeader={headers}
      renderAdditionalRow={false}
      tableHeaderCustomStyles={{
        '.MuiTableCell-head': {
          fontFamily: 'Poppins, sans-serif',
          fontSize: 14,
          fontWeight: 500,
          color: 'primary.main',
          textAlign: 'left',
          backgroundColor: '#F3F8FB',
          // pl: 6,
          '&:nth-of-type(1)': {
            width: 70,
          },
          '&:nth-of-type(2)': {
            pl: 2,
            width: 250,
          },
        },
      }}
      rowCustomStyles={{
        '.MuiTableCell-root': {
          overflowWrap: 'anywhere',
          textAlign: 'left',
          verticalAlign: 'top',
          py: 2,
          '& .MuiFormControl-root, & .MuiOutlinedInput-root': {
            m: 0,
          },
        },
      }}
      boxStyles={{ minHeight: '0', minWidth: 450 }}
    />
  );
}

export default function DisclosureOfExcluded(): JSX.Element {
  const [disclosureData, setDisclosureData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [dialogbox, setDialogBox] = useState<{
    Index?: number;
  } | null>(null);
  const history = useHistory();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '', id: authId = '' } = useSelector((store: RootStateType) => store.auth);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { enqueueSnackbar } = useSnackbar();
  const { esignReferenceId } = referenceDetail;
  const [openPopup, setOpenPopup] = useState<{ disclosureOfExclusionsCheck: boolean } | null>(null);
  const { investorEditObj } = useSelector((store: RootStateType) => store.investorEditObj);
  const [investorRouteObj, setInvestorRouteObj] = useState<InvestorEditRouteLinkObj | null>(null);
  const [openPreviewConfirmationPopup, setOpenPreviewConfirmationPopup] = useState(false);

  useEffect(() => {
    setDisclosureData({
      ...disclosureData,
      isDisclosureOfExclusionsToBeFilledByInvestor:
        application?.isDisclosureOfExclusionsToBeFilledByInvestor ||
        initialValues.isDisclosureOfExclusionsToBeFilledByInvestor,
      excludedCompaniesCheck: application?.excludedCompaniesCheck || '',
      excludedcompanies: application?.excludedcompanies.length
        ? application.excludedcompanies?.map((excludedCompanies, index) => {
            return { ...excludedCompanies, sno: index };
          })
        : [],
    });
    const routeLinkObj =
      (investorEditObj && investorEditObj?.length > 0) ||
      (APMIFlow && referenceDetail?.applicant_type === '1')
        ? getInvestorRouteLinks(
            investorEditObj as InvestorEditErrorObj[],
            history?.location?.pathname?.split('/')?.pop() || '',
            referenceDetail
          )
        : null;
    setInvestorRouteObj(routeLinkObj);
  }, [application]);

  const { referenceId: referenceIdForInvestorPhotoCapture } = useParams<{ referenceId: string }>();

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  const handleSubmit = async (values: Values) => {
    try {
      const {
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { excludedcompanies, saveType, ...rest } = values;
      const isSaveLater = saveType !== 'save and proceed';

      const updatedPayload = {
        ...application,
        ...rest,
        excludedcompanies:
          YesNoMaster[rest.excludedCompaniesCheck] === YesNoMaster.yes
            ? excludedcompanies
                ?.filter((company) => company?.id || company.isActive)
                ?.map((companiesData) => {
                  const { sno, ...rest } = companiesData;
                  return rest;
                })
            : (excludedcompanies
                ?.map((excludedCompany) => {
                  if (excludedCompany.id) {
                    const { sno, ...rest } = excludedCompany;
                    return { ...rest, isActive: false };
                  }
                  return;
                })
                ?.filter((ele) => ele) as ExcludedCompanyType[]),
      };
      const checkApplication = applicationComparison(
        {
          ...application,
          excludedcompanies: application?.excludedcompanies?.sort(
            (company1, company2) => Number(company1.id) - Number(company2.id)
          ),
        },
        {
          ...updatedPayload,
          excludedcompanies: updatedPayload?.excludedcompanies?.sort(
            (company1, company2) => Number(company1.id) - Number(company2.id)
          ),
          currentStep: !!currentStep && currentStep > 10 ? currentStep : Number(currentStep) + 1,
        }
      );

      //save for later route for investor at liveliness
      const investorEditSaveelaterRoute =
        referenceIdForInvestorPhotoCapture &&
        saveForLaterInvestorPhotoCapture(referenceIdForInvestorPhotoCapture, application);
      const referenceIdForSaveProceedRoute = referenceIdForInvestorPhotoCapture
        ? referenceIdForInvestorPhotoCapture
        : esignReferenceId;

      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...updatedPayload,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role) &&
                !amcuserAsInvestor
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: investorRouteObj ? currentStep : 11,
              ...(APMIFlow && {
                editedByPrimaryApplicant: investorRouteObj
                  ? true
                  : application?.editedByPrimaryApplicant,
              }),
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        setLoading(false);
        !isSaveLater
          ? investorRouteObj
            ? investorRouteObj.saveAndProceedSectionLink
              ? history.push(investorRouteObj.saveAndProceedSectionLink, {
                  id,
                  applicant1ReferenceId: referenceIdForSaveProceedRoute,
                })
              : APMIFlow && referenceDetail?.applicant_type === '1'
              ? history.push(`/investment-details/${esignReferenceId}/application-details`)
              : setOpenPreviewConfirmationPopup(true)
            : history.push('related-party-consent', {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
          : referenceIdForInvestorPhotoCapture && !investorRouteObj
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : investorRouteObj
          ? investorRouteObj.backSectionLink
            ? history.push(investorRouteObj.backSectionLink, {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
            : history.push(
                `/investment-details/${referenceDetail.esignReferenceId}/application-details`
              )
          : history.push(saveForLater(role, id, esignReferenceId, amcuserAsInvestor));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? investorRouteObj
            ? investorRouteObj.saveAndProceedSectionLink
              ? history.push(investorRouteObj.saveAndProceedSectionLink, {
                  id,
                  applicant1ReferenceId: referenceIdForSaveProceedRoute,
                })
              : APMIFlow && referenceDetail?.applicant_type === '1'
              ? history.push(`/investment-details/${esignReferenceId}/application-details`)
              : setOpenPreviewConfirmationPopup(true)
            : history.push('related-party-consent', {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
          : referenceIdForInvestorPhotoCapture && !investorRouteObj
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : investorRouteObj
          ? investorRouteObj.backSectionLink
            ? history.push(investorRouteObj.backSectionLink, {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
            : history.push(
                `/investment-details/${referenceDetail.esignReferenceId}/application-details`
              )
          : history.push(saveForLater(role, id, esignReferenceId, amcuserAsInvestor));
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <>
      <Formik
        initialValues={disclosureData}
        onSubmit={handleSubmit}
        enableReinitialize={true}
        validate={(values: Values) => {
          try {
            validateYupSchema(
              values,
              disclosureOfExcludedSchema(referenceDetail.applicant_type),
              true,
              { ...values, application }
            );
          } catch (e) {
            return yupToFormErrors(e);
          }
        }}>
        {({ handleSubmit, values, setValues, errors }) => (
          <>
            <Grid
              container
              rowSpacing={1}
              //columnSpacing={5}
              sx={{
                width: '100%',
                ml: 0,
                '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
              }}
              component="form"
              noValidate
              onSubmit={handleSubmit}>
              <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#2057A6', mb: 1 }}>
                Identifying any companies that need to be excluded from the portfolio.
              </Typography>
              {SHOW_SECTION_FILLED_BY_INVESTOR_CHECKBOX &&
                !fieldValidateForInvestor(referenceDetail.applicant_type, 1, false) &&
                application &&
                !checkIfApplicationIsNonIndividual(application) &&
                !isPhygital(application as ApplicationProps) && (
                  <Grid xs={12} sx={{ mb: 2 }}>
                    <MFCheckbox
                      name="isDisclosureOfExclusionsToBeFilledByInvestor"
                      label={sectionFilledByInvestor}
                      sx={{ display: 'flex' }}
                      onChange={({ target: { checked } }) => {
                        !checked &&
                          setValues({
                            ...values,
                            isDisclosureOfExclusionsToBeFilledByInvestor: checked,
                          });
                        checked && setOpenPopup({ disclosureOfExclusionsCheck: checked });
                      }}
                      checked={values.isDisclosureOfExclusionsToBeFilledByInvestor}
                      disabled={APMIFlow ? true : false}
                    />
                  </Grid>
                )}
              <SubHeading
                sx={{
                  color: '#131836',
                  fontSize: 18,
                  fontWeight: 500,
                  mt: 0,
                  mb: 5,
                }}>{`Excluded Companies`}</SubHeading>
              <Grid xs={12} sm={12} lg={12}>
                <UseRadioGroup
                  formLabel={`Do you want to exclude any specific companies from your investment portfolio? ${
                    isPhygital(application as ApplicationProps) ||
                    checkIfApplicationIsNonIndividual(application as ApplicationProps) ||
                    !(
                      values.isDisclosureOfExclusionsToBeFilledByInvestor &&
                      !fieldValidateForInvestor(referenceDetail.applicant_type, 1, false)
                    )
                      ? '*'
                      : ''
                  }`}
                  name="excludedCompaniesCheck"
                  items={Object.keys(YesNoMaster).map((fundType) => ({
                    label: YesNoMaster[fundType],
                    value: fundType,
                  }))}
                  disabled={
                    getDisableStatusForjointHolder(
                      role,
                      referenceDetail.applicant_type,
                      amcuserAsInvestor
                    ) ||
                    (APMIFlow
                      ? false
                      : values.isDisclosureOfExclusionsToBeFilledByInvestor &&
                        !fieldValidateForInvestor(referenceDetail.applicant_type, 1, false))
                  }
                  onChange={(e) => {
                    setValues({
                      ...values,
                      excludedCompaniesCheck: e.target.value,
                      excludedcompanies:
                        values.excludedcompanies?.filter((data) => data.isActive).length === 0 &&
                        YesNoMaster[e.target.value] === YesNoMaster.yes
                          ? [
                              ...values.excludedcompanies,
                              { ...newExcludedCompany, sno: values.excludedcompanies?.length },
                            ]
                          : values.excludedcompanies,
                    });
                  }}
                />
              </Grid>
              {YesNoMaster[values.excludedCompaniesCheck] === YesNoMaster.yes && (
                <Grid xs={12} sm={12} lg={12}>
                  <Typography sx={{ fontWeight: 500, fontSize: 16, my: 3 }}>
                    I do not wish to invest in the following bodies companies:
                  </Typography>
                  <DisclosureOfExcludedTable
                    values={values}
                    setDialogBox={setDialogBox}
                    amcuserAsInvestor={amcuserAsInvestor}
                  />
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      sx={{
                        color: 'primary.main',
                        fontWeight: 500,
                        fontSize: 14,
                        mt: 2,
                        px: 4,
                      }}
                      onClick={() => {
                        setValues({
                          ...values,
                          excludedcompanies: [
                            ...values.excludedcompanies,
                            { ...newExcludedCompany, sno: values.excludedcompanies?.length },
                          ],
                        });
                      }}
                      disabled={
                        // getDisableStatusForjointHolder(role,referenceDetail.applicant_type)
                        getDisableStatusForjointHolder(
                          role,
                          referenceDetail.applicant_type,
                          amcuserAsInvestor
                        )
                      }>
                      Add Company
                    </Button>
                  </Grid>
                </Grid>
              )}
              <ConfirmationDialog
                message={`Are you sure you want to delete the company ?`}
                open={dialogbox !== null}
                setOpen={() => setDialogBox(null)}
                onSave={() => {
                  setValues({
                    ...values,
                    excludedcompanies: values.excludedcompanies?.map((data, ind) => {
                      if (data.sno === dialogbox?.Index) {
                        return { ...data, isActive: false };
                      }
                      return data;
                    }),
                  });
                  setDialogBox(null);
                }}
                onCancel={() => setDialogBox(null)}
              />
              <ProceedSaveLater
                saveLater={() => {
                  setValues({
                    ...values,
                    saveType: 'save for later',
                  });
                }}
                saveAndProceed={() => {
                  setValues({
                    ...values,
                    saveType: 'save and proceed',
                  });
                }}
                loader={loading}
                clickedButton={values.saveType}
                saveForLaterButtonText={
                  investorRouteObj
                    ? investorRouteObj.backSectionLink
                      ? `Save and Back To ${investorRouteObj.backSectionName}`
                      : 'Save For Later'
                    : 'Save For Later'
                }
                saveButtonText={
                  investorRouteObj
                    ? investorRouteObj.saveAndProceedSectionLink
                      ? 'Save and Proceed'
                      : 'Save Application'
                    : 'Save and Proceed'
                }
                showEndIcon={
                  investorRouteObj
                    ? investorRouteObj.saveAndProceedSectionLink
                      ? true
                      : false
                    : true
                }
                showSaveForLater={
                  investorRouteObj ? (investorRouteObj.backSectionLink ? true : false) : true
                }
              />
              <ConfirmationDialog
                message={`Are you sure you do not wish to fill this step ?`}
                open={openPopup !== null}
                setOpen={() => {
                  setOpenPopup(null);
                }}
                onSave={() => {
                  setValues({
                    ...values,
                    isDisclosureOfExclusionsToBeFilledByInvestor:
                      openPopup?.disclosureOfExclusionsCheck as boolean,
                    excludedCompaniesCheck: '',
                    excludedcompanies: values.excludedcompanies?.map((data) => {
                      return { ...data, isActive: false };
                    }),
                  });
                  setOpenPopup(null);
                }}
                onCancel={() => {
                  setOpenPopup(null);
                }}
              />
              <ConfirmationDialog
                message={`Application Saved successfully and no further edits provided, Are you sure you want to go back to preview?`}
                open={openPreviewConfirmationPopup}
                setOpen={() => {
                  setOpenPreviewConfirmationPopup(false);
                }}
                onSave={() => {
                  setOpenPreviewConfirmationPopup(false);
                  history.push(`/investment-details/${esignReferenceId}/application-details`);
                }}
                onCancel={() => {
                  setOpenPreviewConfirmationPopup(false);
                }}
              />
            </Grid>
          </>
        )}
      </Formik>
    </>
  );
}
